import { render } from "./Coliseo.vue?vue&type=template&id=b41d4994&scoped=true"
import script from "./Coliseo.vue?vue&type=script&lang=js"
export * from "./Coliseo.vue?vue&type=script&lang=js"

import "./Coliseo.vue?vue&type=style&index=0&id=b41d4994&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41d4994"]])

export default __exports__